import * as actionsTypes from './actionsTypes';
import * as API from '../../API/API';
import * as utils from '../../utils/utils';

export const fetchPersonInfo = type => {
  return dispatch => {
    return dispatch({
      type: actionsTypes.FETCH_PERSON_INFO,
      payload: Promise.all([
        API.fetch_person_images(type),
        API.fetch_person_credits(type),
        API.fetch_person_details(type),
      ]).then(data => {
        return utils.reduceTitles(data);
      }),
    });
  };
};
